import React from 'react';
import PropTypes from 'prop-types';

export default function CommentBlock({ children }) {
  return children ? (
    <div className="success-item-right !mb-0 !pb-0 !border-none">
      <div className="mb-2">
        <div className="text-s mt-20 leading-4">{children}</div>
      </div>
    </div>
  ) : null;
}
CommentBlock.propTypes = {
  children: PropTypes.any,
};
